import { useCallback } from 'react';

import { useQueryClient } from '@tanstack/react-query';

import { communityMemberPostsKeys } from './useCommunityMemberPosts';
import { communityPostsKeys } from './useCommunityPosts';

// The feeds cache the placeholder posts the API serves for a locked channel, so they are refetched once it opens.
export const useInvalidateCommunityFeeds = () => {
  const queryClient = useQueryClient();

  return useCallback(() => {
    queryClient.invalidateQueries({ queryKey: communityPostsKeys.all });
    queryClient.invalidateQueries({ queryKey: communityMemberPostsKeys.all });
  }, [queryClient]);
};
